var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.8V1.97647C0 1.43294 0.185368 0.967812 0.556105 0.581082C0.927474 0.193694 1.37368 0 1.89474 0H13.2632C13.7842 0 14.2304 0.193694 14.6018 0.581082C14.9725 0.967812 15.1579 1.43294 15.1579 1.97647V6.99176C15 6.95882 14.8462 6.93807 14.6965 6.92951C14.5462 6.9216 14.3842 6.91765 14.2105 6.91765C14.0368 6.91765 13.8752 6.9216 13.7255 6.92951C13.5752 6.93807 13.4211 6.95882 13.2632 6.99176V1.97647H1.89474V12.0318L2.06053 11.8588H8.59737C8.56579 12.0235 8.54589 12.1843 8.53768 12.3411C8.5301 12.4972 8.52632 12.6659 8.52632 12.8471C8.52632 13.0282 8.5301 13.1969 8.53768 13.353C8.54589 13.5098 8.56579 13.6706 8.59737 13.8353H2.84211L0 16.8ZM3.78947 5.92941V3.95294H11.3684V5.92941H3.78947ZM3.78947 9.88235V7.90588H8.52632V9.88235H3.78947ZM13.2632 16.8V13.8353H10.4211V11.8588H13.2632V8.89412H15.1579V11.8588H18V13.8353H15.1579V16.8H13.2632Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector (3).ca3839f9da04249c05b1fd83502b0e68.svg";
export { ForwardRef as ReactComponent };